__turbopack_context__.v({
  "modal-content": "xBjGyG_modal-content",
  "modal-content--preview": "xBjGyG_modal-content--preview",
  "modal-content__download-container": "xBjGyG_modal-content__download-container",
  "modal-content__form": "xBjGyG_modal-content__form",
  "modal-content__iframe": "xBjGyG_modal-content__iframe",
  "modal-content__preview-button": "xBjGyG_modal-content__preview-button",
  "modal-content__preview-button-icon": "xBjGyG_modal-content__preview-button-icon",
});
